import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

/**
 * Reads the carved-bundle theme's `sm` breakpoint (48em / 768px) and reports
 * whether the viewport is below it. Below `sm` is the mobile/desktop boundary
 * locked at epic-016 EPIC_BRIEF Breakpoint Cadence — card view, filter drawer,
 * and ResponsiveModal → Drawer all gate on this hook.
 *
 * Sprint-115 SESSION_001 (epic-016 Sprint B). First responsive primitive in
 * Frontend-MineMiner; the contract here is the artifact the table-pattern ADR
 * (decisions/001-table-responsiveness-pattern.md) writes up at Sprint B retro.
 *
 * SSR / first-paint default: when `useMediaQuery` returns undefined (the
 * window matchMedia API hasn't settled yet), `isCompact` falls back to `false`
 * so the desktop branch renders. Matches the core-admin AliasReviewList
 * precedent's behavior.
 */
export interface ResponsiveTableState {
  readonly isCompact: boolean;
}

export const useResponsiveTable = (): ResponsiveTableState => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`) ?? true;
  return { isCompact: !isDesktop };
};
